import {
  EDITOR_TIMELINE_STORE, EditorTimelineStore,
  EDITOR_CONTEXT_MENU_STORE, EditorContextMenuStore,
  EDITOR_GROUPS_STORE, EditorGroupsStore,
  EDITOR_INTERACTIVE_AREAS_STORE, EditorInteractiveAreasStore
} from 'store';
import { EnumLiteralsOf } from 'utilities';

export interface ActionsInCenterProps {
  [EDITOR_TIMELINE_STORE]?: EditorTimelineStore;
  [EDITOR_CONTEXT_MENU_STORE]?: EditorContextMenuStore;
  [EDITOR_GROUPS_STORE]?: EditorGroupsStore;
  [EDITOR_INTERACTIVE_AREAS_STORE]?: EditorInteractiveAreasStore;
}


export const directionTypes = {
  previous: 'previous' as 'previous',
  next: 'next' as 'next'
};
export type DirectionTypes = EnumLiteralsOf<typeof directionTypes>;

export interface JumpToButtonProps {
  direction: DirectionTypes;
  onClick: () => void;
  disabled: boolean;
}